import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/css/Rockwell.css";
import React, { useEffect, useState } from "react";
import data from "../../src/component/ApiUrl/meta_api";
import { Helmet } from "react-helmet";

function Rockwell() {
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const RockwellMeta = data[0]?.Rockwell_page;
    if (RockwellMeta) {
      setMeta(RockwellMeta);
    }
  };
  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  return (
    <>
      {/* Page Header */}
      <div className="container-fluid page-header py-5 mb-5 animate__animated animate__fadeIn">
        <Helmet>
          <title>{meta ? meta.title : "Rockwell - SKimitar Hindustan"}</title>
          <meta
            name="description"
            content="Learn about Skimitar Hindustan's PLC,HMI and Variable Frequency Drives in industrial automation solutions."
          />
        </Helmet>
        <div className="container py-5">
          <h1 className="display-3 text-white animate__animated animate__slideInRight">
            Rockwell
          </h1>
          <nav aria-label="breadcrumb ">
            <ol className="breadcrumb animate__animated animate__slideInRight mb-0">
              <li className="breadcrumb-item text-white">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item text-white">
                <Link to="#">Products</Link>
              </li>
              <li
                className="breadcrumb-item active text-white"
                aria-current="page"
              >
                Rockwell
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container py-5 my-4">
        <div className="row align-items-center g-5">
          <div className="col-lg-6 col-md-6 pe-lg-5" data-aos="fade-right">
            <h1 className="text-gradient-danger mb-0">
              <span className="d-block  fw-bold">
                Rockwell
                <span className="text-danger"> Automation Solutions</span>
              </span>
            </h1>

            <p className="lead fs-6 mb-4 justified-text">
              Cutting-edge automation technology for unparalleled industrial
              efficiency and operational excellence.
            </p>

            <div className="bg-light p-4 rounded-4 mb-4 border-start border-4 border-danger">
              <p className="mb-0 fs-6 justified-text">
                Rockwell Automation delivers industry-leading solutions that
                enhance efficiency, productivity, and scalability across
                industrial applications. Our certified integration ensures
                optimal performance of your automation infrastructure.
              </p>
            </div>

            <div className="row g-3">
              <div className="col-6">
                <div className="d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  <span>PLCs & HMIs</span>
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  <span>Variable Frequency Drives</span>
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  <span>SCADA Systems</span>
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  <span>DCS Solutions</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6" data-aos="fade-left">
            <div className="position-relative">
              <img
                className="Digitalization rounded-4 shadow-lg"
                src={require("../assets/img/products/Rockwell/24ba1d9e883ccb38c9c0ded56ae3fd54.jpg")}
                alt="Rockwell Automation Products"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid bg-light bg-opacity-25 py-5">
        {/* Header Section */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <h1 className=" fw-bold mb-3">
              Allen-Bradley <span className="text-dark">ControlLogix</span> &{" "}
              <span className="text-dark">CompactLogix</span>
            </h1>
          </div>
        </div>

        {/* Content Section */}
        <div className="row justify-content-center align-items-center g-5">
          <div className="col-lg-5">
            <div className="card border-0 shadow-lg overflow-hidden">
              <img
                src={require("../assets/img/products/Rockwell/rockwell-automation-products-768x432.jpg")}
                className=" Digitalization"
                alt="Allen-Bradley PLC Systems"
              />
              <div className="card-footer bg-white border-0">
                <div className="d-flex align-items-center">
                  <i className="bi bi-shield-check fs-4 text-primary me-2"></i>
                  <div>
                    <p className="mb-0 fw-bold">
                      Certified Industrial Solutions
                    </p>
                    <small className="text-muted">
                      Rockwell Automation Partner
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="card border-0 bg-white shadow-sm p-4 mb-4">
              <div className="card-body">
                <p className="card-text justified-text fs-6">
                  Rockwell Automation's Allen-Bradley ControlLogix and
                  CompactLogix PLCs deliver high-speed, scalable, and integrated
                  automation solutions with seamless IoT and cloud connectivity.
                </p>
              </div>
            </div>

            <h3 className="h4 fw-bold mb-4">Key Applications</h3>

            <div className="row g-3">
              <div className="col-md-6">
                <div className="d-flex p-3 bg-white rounded shadow-sm">
                  <i className="bi bi-check-circle-fill text-danger mt-1 me-3"></i>
                  <div>
                    <h4 className="h6 fw-bold mb-1">
                      Manufacturing Automation
                    </h4>
                    <p className="small text-muted mb-0">
                      Precision assembly line control
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="d-flex p-3 bg-white rounded shadow-sm">
                  <i className="bi bi-check-circle-fill text-danger mt-1 me-3"></i>
                  <div>
                    <h4 className="h6 fw-bold mb-1">Food Processing</h4>
                    <p className="small text-muted mb-0">
                      HACCP-compliant systems
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="d-flex p-3 bg-white rounded shadow-sm">
                  <i className="bi bi-check-circle-fill text-danger mt-1 me-3"></i>
                  <div>
                    <h4 className="h6 fw-bold mb-1">Water Treatment</h4>
                    <p className="small text-muted mb-0">
                      Plant-wide automation
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="d-flex p-3 bg-white rounded shadow-sm">
                  <i className="bi bi-check-circle-fill text-danger mt-1 me-3"></i>
                  <div>
                    <h4 className="h6 fw-bold mb-1">Power Generation</h4>
                    <p className="small text-muted mb-0">
                      Critical infrastructure control
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="smart-services p-3">
        <div className="container-fluid px-0">
          <div className="row g-0">
            <div className="col-lg-6 p-3 ">
              <div
                className="service-header  bg-gradient p-4 p-md-5 rounded-3 mb-4 ms-lg-5"
                style={{ backgroundColor: "#e9ecef" }}
              >
                <h2
                  className="text-gradient-primary fw-bold mb-4"
                  data-aos="fade-left"
                >
                  Smart Solutions Robotics Solutions
                </h2>
                <p className="text-dark mb-0 fs-6 justified-text">
                  Transform your home into an intelligent ecosystem designed for
                  comfort, security, and efficiency. Our cutting-edge smart home
                  solutions bring together the latest technology to create a
                  living space that anticipates your needs and simplifies your
                  daily routine.
                </p>
              </div>

              <div className="row g-4 ms-lg-5">
                {/* Service 1 */}
                <div className="col-md-6">
                  <div className="card h-100 border-0 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div className=" ">
                        <i
                          className="bi bi-cpu text-danger p-3"
                          // style={{ fontSize: "1.5rem" }}
                        ></i>
                      </div>
                      <h5 className="card-title fw-bold mb-0">
                        Smart Device Installation
                      </h5>
                    </div>
                    <p className="fs-6">
                      We bring the right people together to challenge
                      established thinking and drive transform in 2020
                    </p>
                  </div>
                </div>

                {/* Service 2 */}
                <div className="col-md-6">
                  <div className="card h-100 border-0 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div className="">
                        <i
                          className="bi bi-grid text-danger  p-2 text-center"
                          // style={{ fontSize: "1.5rem" }}
                        ></i>
                      </div>
                      <h5 className=" fw-bold mb-0">Custom Home Automation</h5>
                    </div>
                    <p className="fs-6">
                      We bring the right people together to challenge
                      established thinking and drive transform in 2020
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right section with full-width image */}
            <div className="col-lg-6 d-none d-lg-block p-3">
              {" "}
              {/* Removed padding */}
              <div className="h-100 w-100">
                <img
                  src="https://images.unsplash.com/photo-1593784991095-a205069470b6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                  alt="Smart home automation"
                  className="img-fluid w-100 h-100 rounded pe-4"
                  style={{ objectFit: "cover", objectPosition: "center" }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Add Bootstrap Icons CSS */}
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
        />
      </section>

      <section className=" text-light  mt-3">
        <div className="container py-4">
          {/* Section Header */}
          <div className="row mb-3">
            <div className="col-12 text-center">
              <h2
                className="text-gradient-primary fw-bold mb-4"
                data-aos="fade-left"
              >
                Why Choose HomeSecure?
              </h2>
              <div
                className="bg-dark mx-auto"
                style={{ height: "4px", width: "80px", borderRadius: "2px" }}
              ></div>
            </div>
          </div>

          {/* Benefits Cards */}
          <div className="row justify-content-center mb-2 g-4">
            <div className="col-md-4">
              <div className="card h-100 bg-white border-0 rounded-4 p-3 text-center shadow">
                <div className="mb-4 d-flex justify-content-center">
                  <div
                    className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i className="bi bi-piggy-bank fs-2"></i>
                  </div>
                </div>
                <h4 className="card-title">
                  Save your money and stay comfortable.
                </h4>
                <p className="card-text text-light-emphasis justified-text">
                  Our smart systems optimize energy usage and reduce utility
                  bills while maintaining ideal comfort levels throughout your
                  home.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card h-100 bg-white  border-0 rounded-4 p-3 text-center shadow">
                <div className="mb-4 d-flex justify-content-center">
                  <div
                    className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i className="bi bi-phone fs-2"></i>
                  </div>
                </div>
                <h4 className="card-title">Manage smart home from anywhere.</h4>
                <p className="card-text text-light-emphasis justified-text">
                  Control all your home systems with our intuitive mobile app,
                  giving you complete access and control no matter where you
                  are.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card h-100 bg-white  border-0 rounded-4 p-2 text-center shadow">
                <div className="mb-4 d-flex justify-content-center">
                  <div
                    className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i className="bi bi-chat-dots fs-2"></i>
                  </div>
                </div>
                <h4 className="card-title">
                  Chat with contacts during alarms.
                </h4>
                <p className="card-text text-light-emphasis justified-text">
                  Our integrated communication system connects you directly with
                  family members and emergency contacts when alarms are
                  triggered.
                </p>
              </div>
            </div>
          </div>

          {/* About Company Section */}
          <div className="row align-items-center mt-5 g-4">
            <div className="col-lg-6">
              <div className="position-relative">
                <img
                  src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80"
                  alt="HomeSecure Team"
                  className="img-fluid rounded-4 shadow"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="">
                <p className="fs-6 text-dark mb-2 justified-text">
                  HomeSecure is committed to providing every home and family
                  with innovative, dependable, and affordable home security
                  solutions.
                </p>
                <p className="fs-6 text-dark mb-2 justified-text">
                  We began as a small Austin, Texas security provider in 1992.
                  Our self-installed home security business model quickly grew
                  from local to national with hundreds of thousands of homes
                  secured across all 50 states and Canada.
                </p>

                <p className="fs-6 text-dark mb-2 justified-text">
                  Since then, HomeSecure has continued to protect homes and
                  families in neighborhoods across North America and even
                  expanded to offer cutting-edge home automation and life safety
                  products. Despite dramatic growth and success, our commitment
                  to customer satisfaction remains our top priority.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section position-relative py-5 bg-light">
        {/* Background pattern */}
        <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10">
          <div
            className="w-100 h-100"
            style={{
              backgroundImage:
                "radial-gradient(circle, #e9ecef 1px, transparent 1px)",
              backgroundSize: "30px 30px",
            }}
          ></div>
        </div>

        <div className="container py-4 position-relative">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <h2
                className="text-gradient-primary fw-bold mb-4"
                data-aos="fade-left"
              >
                Give Everything To Rakar AC Repair
              </h2>
              <p className="lead mb-4 fs-6 justified-text">
                Welcome to Rakar when it comes to custom fitting furniture and
                carpentry jobs, handy carpentry is the best option. We are happy
                that you came upon our website.
              </p>

              <div className="d-flex flex-column gap-3 mb-4">
                <div className="d-flex align-items-center">
                  <div className="rounded-circle bg-danger bg-opacity-10 p-2 me-3">
                    <i className="bi bi-check-circle-fill text-danger"></i>
                  </div>
                  <span className="fw-medium">100% qualityful work</span>
                </div>

                <div className="d-flex align-items-center">
                  <div className="rounded-circle bg-danger bg-opacity-10 p-2 me-3">
                    <i className="bi bi-check-circle-fill text-danger"></i>
                  </div>
                  <span className="fw-medium">Unifored Licensed Worker</span>
                </div>

                <div className="d-flex align-items-center">
                  <div className="rounded-circle bg-danger bg-opacity-10 p-2 me-3">
                    <i className="bi bi-check-circle-fill text-danger"></i>
                  </div>
                  <span className="fw-medium">An Affordable Pricing Plans</span>
                </div>
              </div>
            </div>

            <div className="col-lg-6 position-relative">
              <div className="position-relative">
                {/* Main circular image */}
                <div
                  className="rounded-circle overflow-hidden border border-5 border-white shadow-lg"
                  style={{ width: "400px", height: "400px" }}
                >
                  <img
                    src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80"
                    alt="AC Repair Technician"
                    className="Digitalization object-fit-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="p-5 bg-light">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h3 className="text-gradient-primary text-center fs-3 fw-bold mt-1">
                {" "}
                Allen-Bradley PanelView - Human-Machine Interfaces (HMI)
              </h3>

              {/* <h3 className="text-primary"> Harmony HMI Series</h3> */}
            </div>
            <div className="col-lg-6  pt-3">
              <img
                className="Digitalization mt-5"
                src={require("../assets/img/products/Rockwell/rockwell-automation-products-768x432.jpg")}
                alt="Image 3"
              />
            </div>
            <div className="col-lg-6  marginTB mt-5" data-aos="zoom-out">
              <p className="text-black mt-3">
                <p className="centercardpara fs-6 justified-text">
                  The Allen-Bradley PanelView HMI series provides intuitive and
                  high- performance visualization solutions. With modern
                  touchscreens and advanced diagnostics, these HMIs offer
                  real-time monitoring and control for industrial automation.
                </p>

                <h4 className="fw-bold centercardpara mb-2">Applications</h4>
                <p className="centercardpara"> ✔ Factory automation</p>
                <p className="centercardpara">
                  ✔ Packaging and material handling systems
                </p>
                <p className="centercardpara">✔ SCADA and remote monitoring</p>
                <p className="centercardpara">✔ Energy management systems</p>
              </p>
              <p></p>
            </div>
          </div>
        </div>
      </div>

      <div className="py-5 bg-dark text-white position-relative">
        <div className="container position-relative z-1">
          {/* Header */}
          <div className="text-center mb-5">
            <h2 className="display-4 fw-bold">
              Explore <span className="text-danger">PowerFlex</span> VFDs
            </h2>
          </div>

          <div className="row g-5 align-items-center">
            {/* Left - Content */}
            <div className="col-lg-6">
              <div className="mb-4">
                <h3 className="h4 text-danger fw-bold mb-3">
                  <i className="bi bi-flash me-2"></i> Why PowerFlex?
                </h3>
                <p className="fs-6 text-white justified-text">
                  PowerFlex VFDs offer unmatched scalability and performance.
                  From compact drives for basic applications to high-performance
                  solutions for complex systems—PowerFlex brings precision,
                  efficiency, and integration together.
                </p>
              </div>

              <h4 className="h5 text-white mb-4">Industrial Applications</h4>
              <div className="row g-3">
                {[
                  {
                    id: 1,
                    icon: "bi-house-gear",
                    title: "HVAC",
                    desc: "Smart climate management",
                  },
                  {
                    id: 2,
                    icon: "bi-box-seam",
                    title: "Material Handling",
                    desc: "Optimized conveyor control",
                  },
                  {
                    id: 3,
                    icon: "bi-droplet-half",
                    title: "Water Plants",
                    desc: "Pump & flow control",
                  },
                  {
                    id: 4,
                    icon: "bi-building-gear",
                    title: "Factories",
                    desc: "Smooth automation",
                  },
                ].map((item) => (
                  <div className="col-6" key={item.id}>
                    <div className="bg-light text-dark p-3 rounded-3 shadow-sm h-100">
                      <div className="d-flex align-items-center mb-2">
                        <i
                          className={`bi ${item.icon} text-danger fs-4 me-3`}
                        ></i>
                        <h5 className="h6 fw-bold mb-0">{item.title}</h5>
                      </div>
                      <p className="small mb-0">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right - Image with overlay */}
            <div className="col-lg-6">
              <div className="position-relative">
                <img
                  src={require("../assets/img/products/Rockwell/at66-product-solution-kinetix-5300.2560.webp")}
                  className="img-fluid rounded-4 shadow"
                  alt="PowerFlex VFD"
                  loading="lazy"
                />
                <div className="position-absolute top-0 start-0 bg-danger text-white p-3 rounded-bottom-end shadow-sm">
                  <i className="bi bi-patch-check-fill me-2"></i> Official
                  Rockwell Partner
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Background Decorative Element */}
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient bg-opacity-10 z-0" />
      </div>

      <h2 className="text-danger text-gradient-primary text-center fw-bold mt-5">
        {" "}
        FactoryTalk View - Supervisory Control and Data Acquisition(SCADA)
      </h2>

      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-8 marginTB" data-aos="zoom-in">
            <p className="centercardpara mt-5 fs-6 justified-text">
              FactoryTalk View SCADA software by Rockwell Automation offers
              apowerful platform for real-time data monitoring, process control,
              and analytics. It enables improved decision-making and operational
              efficiency through seamless integration with industrial devices.
            </p>
            <h3 className="fw-bold centercardpara">Applications</h3>
            <p className="centercardpara mt-5">
              ✔Remote monitoring of industrial processes{" "}
            </p>
            <p className="centercardpara">✔Power grid and energy management</p>
            <p className="centercardpara">
              ✔Water and wastewater treatment plants
            </p>
            <p className="centercardpara">✔Oil and gas pipeline automation</p>
          </div>
          <div className="col-lg-6  col-md-4 mt-5">
            <div className="row mt-5 px-4">
              <div
                className="col-lg-10 d-flex justify-content-center px-6"
                data-aos="fade-left"
              >
                <img
                  className=" Digitalization"
                  src={require("../assets/img/products/Rockwell/image2_1.webp")}
                  alt="Image 3"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="  container">
        <div className="row"></div>
        <div className="row">
          <div
            className="col-lg-6 col-md-8 marginTB expand"
            data-aos="fade-right"
          >
            {/* <h2 className="text-warning"> Motors (SIMOTICS Series)</h2> */}
            <img
              className=" Digitalization me-6 pe-4 mt-5 pt-4"
              src={require("../assets/img/products/Rockwell/2696359.jpeg")}
              alt="Image 3"
            />
          </div>
          <div className="col-lg-6  col-md-4 mt-5 ">
            <div className="row mt-5 mx-5">
              <h4 className="text-danger text-gradient-primary">
                {" "}
                PlantPAx - Distributed Control Systems (DCS)
              </h4>

              <p className="centercardpara fs-6 justified-text">
                Rockwell Automation's PlantPAx Distributed Control System(DCS)
                provides a modern, scalable, and secure solution for process
                automation. Designedfor high-performance control, it integrates
                seamlessly with Rockwell's automation ecosystem.
              </p>
              <p className="centercardpara fs-5 fw-bold">Applications</p>
              <p className="centercardpara"> Oil and gas process automation</p>
              <p className="centercardpara">
                {" "}
                Chemical and pharmaceutical industries{" "}
              </p>
              <p className="centercardpara"> Power generation plants</p>
              <p className="centercardpara"> Mining and metals processing</p>
              <div
                className="col-lg-10 d-flex justify-content-center mt-5"
                data-aos="fade-left"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Rockwell;
